import { BoxIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import { getAddonCatalog } from "common";
import { isEmpty } from "lodash";
import React from "react";
import { Experience } from "types";
import { Currency } from "../Common/Currency";
import { NoTranslate } from "../Common/NoTranslate";
import { isQuestionnaireAddOn } from "@/models/CatalogItem";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const CreatePurchaseAddOnSkeleton = () => {
    const activeProduct = useCreatePurchaseStore((state) => state.getActiveProduct());
    const catalogItems = getAddonCatalog(activeProduct as Experience) ?? [];

    const filteredCatalogItems = catalogItems.filter(
        (catalogItem) => catalogItem.type !== null && !isQuestionnaireAddOn(catalogItem),
    );

    if (filteredCatalogItems.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-col space-y-4 py-2 pt-6">
            <span className="flex items-center space-x-2">
                <span className="text-lg font-bold tracking-tight">Add-ons</span>
                {filteredCatalogItems.length > 0 && (
                    <Badge color="warning" size="small" icon={<BoxIcon className="top-0" />}>
                        {filteredCatalogItems.length}
                    </Badge>
                )}
            </span>
            {filteredCatalogItems.map((catalog) => {
                return (
                    <div key={catalog.id} className="h-[60px] !justify-start">
                        <div className="flex justify-start rounded">
                            <div className="mr-7 h-[56px] w-[56px] flex-shrink-0 rounded bg-gray-lighter">&nbsp;</div>
                            <div className="flex flex-col justify-center">
                                <NoTranslate as="div" className="font-semibold">
                                    {catalog.name}
                                </NoTranslate>
                                <div>
                                    {!isEmpty(catalog.prices) && (
                                        <>
                                            <var data-var="addonPrice">
                                                <Currency>{catalog.prices?.price?.min}</Currency>
                                            </var>
                                            /add-on
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
